import { useTranslation } from "next-i18next"
import { NotificationListView } from "../components/NotificationListView"
import { useNotifications } from "../hooks/useNotifications"
import { NotificationCategory } from "../types/notificationCategory"
import { NotificationScope } from "../types/notificationScope"
import { Illustration } from "@/core/components/Illustration"

type TNotificationListContainerProps = {
  scope: NotificationScope
  category: NotificationCategory
}

export const NotificationListContainer = ({
  scope,
  category,
}: TNotificationListContainerProps) => {
  const { t } = useTranslation("notifications")
  const { notifications, isFetching, isFetched, fetchNextPage, isError } =
    useNotifications(scope, category)

  if (isError) {
    return (
      <div className="text-on-surface-variant mx-auto flex h-full w-2/3 flex-col items-center justify-center gap-4 pt-10 text-center">
        <Illustration name="inbox-empty" />
        {t("error_fetching_notifications")}
      </div>
    )
  }

  if (isFetched && notifications.length === 0) {
    return (
      <div className="text-on-surface-variant h-full bg-white pt-10 text-center">
        {t("no_notifications")}
      </div>
    )
  }

  return (
    <NotificationListView
      category={category}
      notifications={notifications}
      isFetching={isFetching}
      onEndReached={fetchNextPage}
    />
  )
}
